import React from "react";
import { connect, useDispatch } from "react-redux";
import HeaderBar from "../../components/Header/HeaderBar";
import ContentWrapper from "../../components/ContentWrapper";
import axios from "../../services/axios/backendAxios";
import { updateUser } from "../../store/reducers/currentUserSlice";
import flash from "../../services/flash";
import Referrals from "./Referrals";
import AddUserToCompany from "./AddUserToCompany";
import TransferOwnership from "./TransferOwnership";
import CompanyDetails from "./CompanyDetails";
import UserInfo from "./UserInfo";
import ConfigCatRefresh from "./ConfigCatRefresh";

const sectionStyle =
  "md:bg-full-white md:p-3 md:rounded-md mb-12 md:border border-[#cccccc] max-h-[500px] overflow-scroll";

const SnowScapeAdmin = () => {
  const dispatch = useDispatch();
  const impersonate = async (phoneNumber) => {
    try {
      await axios.post("/user/impersonate", { phone: phoneNumber });
    } catch (err) {
      if (err.response?.data?.message) {
        flash.error(err.response.data.message);
      }
    }
    let userResponse = await axios.get("/user/me");
    await dispatch({ type: "SIGNOUT_CLEAR_STORE" });
    await dispatch(
      updateUser({
        ...userResponse.data.user,
        is_impersonating: userResponse.data.is_impersonating ?? false,
      }),
    );
    // window.location.reload();
  };

  return (
    <>
      <HeaderBar title="SnowScape Dashboard" />
      <ContentWrapper>
        <div className="grid grid-cols-3 gap-2">
          <section className={sectionStyle}>
            <UserInfo />
          </section>
          <section className={sectionStyle}>
            <CompanyDetails />
          </section>
          <section className={sectionStyle}>
            <AddUserToCompany />
          </section>
          <section className={sectionStyle}>
            <TransferOwnership />
          </section>
          <section className={sectionStyle}>
            <Referrals />
          </section>
          <section className={sectionStyle}>
            <ConfigCatRefresh />
          </section>
        </div>
      </ContentWrapper>
    </>
  );
};

const mapStateToProps = (state) => {
  const { currentUser } = state;
  return { currentUser };
};

export default connect(mapStateToProps)(SnowScapeAdmin);
